import React from "react";
import AnyQuestions from "../../reusable/AnyQuestions";
import { Link } from "react-router-dom";
import BillingAddress from "./BillingAddress";
import ShipingMethod from "./ShipingMethod";
import PaymentMethod from "./PaymentMethod";
import ConfirmOrder from "./ConfirmOrder";
import moment from "moment";
import ShippingAddress from "./ShippingAddress";
class CheckoutMain extends React.Component {

  getPromoDescription(promotion) {
    if(promotion ==  "120") {
      return "50GB US DATA & 1GB GLOBAL DATA";
    }
    else if(promotion == "105") {
      return "20GB US DATA OR 1GB GLOBAL DATA";
    }
    else if(promotion == "79") {
      return "3GB US DATA OR 1GB GLOBAL DATA";
    }
    else {
      return null;
    }
  }

  render() {
    let { cart, product } = this.props;
    const { router } = this.props;
    //const total = (typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal.grandTotal : this.props.cart.total;
    let total = (typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal.grandTotal + this.props.cart.shippingFee : this.props.cart.total;
    let subtotal = (typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? this.props.apply_discount.flatTotal.grandTotal : this.props.cart.subtotal;

    // for confirmation page
    if (typeof this.props.orderPayload !== "undefined" && this.props.orderPayload.total) {
      cart = this.props.orderPayload.cart;
      product = this.props.orderPayload.cart.product;
      if (typeof this.props.orderPayload.after_discount_totals_flat !== "undefined" && this.props.orderPayload.after_discount_totals_flat != null && this.props.orderPayload.after_discount_totals_flat.grandTotal) {
        total = this.props.orderPayload.paypal.transactions[0].amount.total;
      } else {
        total = this.props.orderPayload.total;
      }
    }

    if (total != null) {
      total = parseFloat(total).toFixed(2);
    }
    if (subtotal != null) {
      subtotal = parseFloat(subtotal).toFixed(2);
    }

    console.log("props", this.props);
    return (
        <section>
          <div className="container">
            <div className="row">
              <div className="col-md-4 cart-product-img">
                <img src={product.image} alt="" />
                {/* <div>
                  <img src="/images/divider.png" alt="" className="img-fluid" />
                </div> */}
                <div className="text-left">
                  <h2 className="cart-product-title">{product.name}</h2>

                  {
                    (cart.cartType === 'device') ? (
                        <div>
                          {
                            (typeof cart.buy_option !== "undefined" && cart.buy_option === "buy_device") ? <strong>BUY DEVICE ONLY</strong> : null
                          }

                          {
                            (typeof cart.buy_option !== "undefined" && cart.buy_option === "buy_device_with_data") ? (

                                <div className="cart-product-subtitle">
                                  <strong>BUY DEVICE WITH DATA PLAN<br/>
                                    <span className="cart-product-subtitle-dc">
                              {
                                typeof cart.promotion !== "undefined" && cart.promotion !== null ? (
                                    this.getPromoDescription(cart.promotion)
                                ) : (
                                    cart.useType === "GLOBAL" && typeof cart.country !== "undefined" && cart.country !== null ? cart.country.name + ' ' + cart.recurring_profile.name : cart.useType + ' ' + cart.recurring_profile.name
                                )
                              }
                            </span>
                                  </strong>
                                </div>

                            ) : null
                          }
                        </div>
                    ) : (
                        <strong>
                          {product.shortDescription}
                          <br/>
                        </strong>
                    )
                  }

                  { cart.cartType === 'device'  && (this.props.data.step2 || this.props.data.step3 || this.props.data.step4 || this.props.data.step5) ?
                      (
                          <div>
                            {/*<p className="mb-0" style={{color:'#0076be',fontWeight:'900'}}>Taxes and Fees {!this.props.cart.tax && "Included"}</p>*/}
                            <p className="mb-0 cart-shipping-notie"> + {cart.shippingFee ? ("Shipping : " + cart.shippingFee) : null } {!cart.shippingFee && "Free Shipping"}</p>
                          </div>
                      ) : null
                  }

                  { cart.cartType === 'sim'  && (this.props.data.step2 || this.props.data.step3 || this.props.data.step4) ?
                      (
                          <div>
                            <p className="mb-0 cart-shipping-notie">+ Taxes and Fees {!cart.tax && "Included"}</p>
                            <p className="mb-0 cart-shipping-notie">+ {cart.shippingFee ? ("Shipping : " + cart.shippingFee.toFixed(2)) : null } {!cart.shippingFee && "Free Shipping"}</p>
                          </div>
                      ) : null
                  }

                  <br/>

                  {
                    (typeof this.props.apply_discount.flatTotal !== "undefined" && typeof this.props.apply_discount.flatTotal.grandTotal !== "undefined") ? (
                            <span className="price-org">
                        {cart.cartType === 'device' ?
                            (<h4 className="mb-0 SansSerif bold100" style={{textDecoration: "line-through"}}>${cart.total.toFixed(2)}</h4>)
                            : null
                        }

                              {cart.cartType === 'sim' ?
                                  (<h4 className="mb-0 SansSerif bold100" style={{textDecoration: "line-through"}}>${cart.total.toFixed(2)}</h4>)
                                  : null
                              }

                              {cart.cartType === 'rent' ?
                                  (<h4 className="mb-0 SansSerif bold100" style={{textDecoration: "line-through"}}>${cart.total.toFixed(2)}</h4>)
                                  : null
                              }
                      </span>
                        )
                        : null
                  }


                  {cart.cartType === 'device' ?
                      (<h4 className="text-custom mt-2 bold600 SansSerif"><span className="bold100">Total:</span> ${total}</h4>)
                      : null
                  }

                  {cart.cartType === 'sim' ?
                      (<h4 className="text-custom mt-2 bold600 SansSerif"><span className="bold100">Total:</span> ${total}</h4>)
                      : null
                  }

                  {cart.cartType === 'rent' ?
                      (<h4 className="text-custom mt-2 bold600 SansSerif"><span className="bold100">Total:</span> ${total}</h4>)
                      : null
                  }

                  { cart.cartType !== 'sim'  && (this.props.data.step2 || this.props.data.step3 || this.props.data.step4) ?
                      (
                          <div>
                            <p className="mb-0 cart-shipping-notie">+ Taxes and Fees</p>
                          </div>
                      ) : null
                  }

                </div>
              </div>
              {this.props.data.step1 ? (
                  <ShippingAddress
                      handleShipping={this.props.handleShipping}
                      back={this.props.backStep1}
                      auth={this.props.auth}
                  />
              ) : null }

              {this.props.data.step2 ? (
                  <BillingAddress
                      handleBilling={this.props.handleBilling}
                      back={this.props.backStep2}
                      auth={this.props.auth}
                  />
              ) : null}
              {this.props.data.step3 ? (
                  <ShipingMethod
                      back={this.props.backStep3}
                      handleShippingMethod={this.props.handleShippingMethod}
                  />
              ) : null}
              {this.props.data.step4 ? (
                  <PaymentMethod
                      back={this.props.backStep4}
                      router={router}
                      handlePayment={this.props.handlePayment}
                      setpaymentMode={this.props.setpaymentMode}
                      handlePaypalPayment={this.props.handlePaypalPayment}
                      calculateTax={this.props.calculateTax}
                      cart={this.props.cart}
                      isAddressFilled={this.props.isAddressFilled}
                      isProcessing={this.props.isProcessing}
                      validateDiscount = {this.props.validateDiscount}
                      setDiscountCode = {this.setDiscountCode}
                      total={total}
                      subtotal={subtotal}
                      discountDetails={this.props.apply_discount}
                      validate_discount_error={this.props.validate_discount_error}
                      recaptchaRef={this.props.recaptchaRef}
                      isHuman={this.props.isHuman}
                      humanKey={this.props.humanKey}
                      verifyCaptcha={this.props.verifyCaptcha}
                      expireCaptcha={this.props.expireCaptcha}
                  />
              ) : null}
              {this.props.data.step5 ? (
                  <ConfirmOrder product={{...this.props.product}} orderPayload={this.props.orderPayload} cart={this.props.cart} />
              ) : null}
            </div>
          </div>
        </section>
    );
  }
}

export default CheckoutMain;



// WEBPACK FOOTER //
// ./src/pages/checkout/CheckoutMain.js